// Bảng màu nền gradient kiểu Facebook cho bài đăng text-only (không ảnh).
// Key PHẢI khớp whitelist backend (BG_PRESET_KEYS trong communityAdminController.js)
// + đồng bộ với frontend/src/pages/Community/community-bg-presets.js.
// Hướng gradient cố định 135deg (to bottom right) cho mọi preset.
export const COMMUNITY_BG_PRESETS = {
    purple: ['#7C3AED', '#C026D3'],
    sunset: ['#F97316', '#EF4444'],
    ocean: ['#0EA5E9', '#6366F1'],
    rose: ['#EC4899', '#F43F5E'],
    emerald: ['#10B981', '#0D9488'],
    night: ['#111827', '#374151'],
    gold: ['#F59E0B', '#F97316'],
    crimson: ['#DC2626', '#7F1D1D'],
    sky: ['#38BDF8', '#0284C7'],
    violet: ['#8B5CF6', '#4F46E5'],
    candy: ['#F472B6', '#FB7185'],
    forest: ['#22C55E', '#15803D'],
};

// Giới hạn áp dụng nền: KHÔNG ảnh + nội dung ngắn (khớp BG_MAX_CONTENT_LENGTH backend)
export const BG_MAX_CONTENT_LENGTH = 200;

/** CSS background (linear-gradient) cho 1 preset key, hoặc null nếu key không hợp lệ. */
export function communityBgGradient(key) {
    const colors = COMMUNITY_BG_PRESETS[key];
    return colors ? `linear-gradient(135deg, ${colors[0]}, ${colors[1]})` : null;
}

export default COMMUNITY_BG_PRESETS;
